import { render } from "./pagamentoRequestConfig.vue?vue&type=template&id=70af6c09&ts=true"
import script from "./pagamentoRequestConfig.vue?vue&type=script&lang=ts"
export * from "./pagamentoRequestConfig.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__